var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid/Brands/Youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31802 6.52073C13.7656 6.17278 18.2335 6.17278 22.6811 6.52073L25.6687 6.75447C27.3328 6.88466 28.6941 8.13185 28.9692 9.77821C29.6575 13.8975 29.6575 18.1025 28.9692 22.2219C28.6941 23.8682 27.3328 25.1154 25.6687 25.2456L22.6811 25.4793C18.2335 25.8273 13.7656 25.8273 9.31802 25.4793L6.33042 25.2456C4.66632 25.1154 3.30496 23.8682 3.02988 22.2219C2.3416 18.1025 2.3416 13.8975 3.02988 9.77821C3.30496 8.13185 4.66632 6.88466 6.33042 6.75447L9.31802 6.52073ZM13.3328 19.2936V12.7065C13.3328 12.3956 13.672 12.2036 13.9386 12.3635L19.4278 15.657C19.6868 15.8124 19.6868 16.1877 19.4278 16.343L13.9386 19.6366C13.672 19.7965 13.3328 19.6045 13.3328 19.2936Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutubeIcon);
export default __webpack_public_path__ + "static/media/footer_youtube_icon.3586625f7c1d434da60bab7a500f4776.svg";
export { ForwardRef as ReactComponent };